<template>
    <div class="row" @click="console.log(visita)">
        <div class="col-lg-4" style="max-width:300px" v-show="propsplanning !=false">
            <div v-if="mostrarFechasVisita" class="mb-2">
                <span v-if="mostrarFechaEnDomicilio" title="Fecha y hora en domicilio"><i class="fa fa-sign-in-alt" aria-hidden="true"></i><span class="ml-2">{{ formatearFecha(visita.visita.fecha_unix_en_domicilio) }}</span></span><br>
                <span v-if="mostrarFechaFin" title="Fecha y hora finalizado"><i class="fa fa-sign-out-alt" aria-hidden="true"></i><span class="ml-2" >{{ formatearFecha(visita.visita.fecha_unix_realizado) }}</span></span>
            </div>
            <servicio-datos-visitas-visita-operario @email="email" :servicio="servicio"
                :id="visita.visita.servicios_idservicios" :visita="visita" />
            <servicio-datos-visitas-visita-cliente @email="email" :servicio="servicio"
                :id="visita.visita.servicios_idservicios" :visita="visita" />
        </div>
        <div class="col-lg-8">
            <div class="flex-wrap">
                <div class="btn-group">
                    <button v-if="visita.accesible == '1'" @click="accederservicio()" title="Ir al servicio" class="btn btn-default ">
                        <i class="fas fa-paste"></i>
                    </button>
                    <button v-if="!finalizada || visita.eliminable == '1'" @click="eliminarvisita()" title="Eliminar visita"
                        class="btn btn-default ">
                        <i class="fas fa-times" style="color:red;"></i>
                    </button>
                    <button type="button" v-if="confirmar" @click="mostrarConfirmar()" title="Confirmar Visita"
                        class="btn btn-default ">
                        <i class="fas fa-align-justify"></i>
                    </button>
                    <button type="button" v-if="mostrarboton==true && visita.accesible == '1'" @click="mostrarTrabajos(propsplanning)"
                        :style="'background:'+colorboton" title="Mostrar Trabajos" class="btn btn-default ">
                        <i class="far fa-plus-square"></i>
                    </button>
                    <button v-if="mostrarPresupuesto && visita.accesible == '1'" type="button" @click="mostrarpresupuestos(propsplanning)"
                        class="btn btn-default " :style="'background:' + colorbotonpresup" title="Presupuesto">
                        <i class="far fa-folder-open"></i>
                    </button>
                    <button type="button" v-if="visita.modificable == '1'" :style="'background:' + colorbotondos"
                        @click="mostrarEditar()" class="btn btn-default " title="Modificar visita">
                        <i class="far fa-edit"></i>
                    </button>
                    <button type="button" v-if="mostrarbotontres == true" title="Mostrar Chat"
                        :style="'background:' + colorbotontres" @click="mostrarChat(propsplanning)"
                        class="btn btn-default ">
                        <i class="far fa-comment-dots"></i>
                        <span style="margin-top: 20px;margin-left: -5px;" v-if="chatsvisita > 0"
                            class="position-absolute bottom-0 start-0 translate-middle badge rounded-pill bg-danger">
                            {{ chatsvisita }}
                        </span>
                    </button>
                    <button v-if="!finalizada" type="button" class="btn btn-default " v-on:click="mostrarFinalizarBtn()"
                        :style="'background:' + colorbotoncuatro" title="Finalizar Visita">
                        <i class="fas fa-check"></i>
                    </button>
                    <div class="btn-group open" style="width: 60px; margin: 0;">
                        <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false" aria-controls="dropdownMenu1">
                            <i class="fas fa-share-square"></i>
                        </button>
                        <ul id="dropdownMenu1" class="dropdown-menu" aria-labelledby="dropdownMenu1">
                            <li class="dropdown-item"><a href="#" @click="parteoperarioemail()">{{
                                    $t('general.enviarfichaemail') }}</a></li>
                            <li class="dropdown-divider"></li>
                            <li class="dropdown-item"><a href="#" @click="smsoperario()">{{ $t('general.smsaloperario')
                                    }}</a></li>
                            <li class="dropdown-item"><a href="#" @click="smsasegurado()">{{
                                    $t('general.smsalasegurado') }}</a></li>
                            <li class="dropdown-item" v-if="ste"><a href="#" @click="steasegurado()">{{
                                    $t('general.firmasteemail') }}</a></li>
                        </ul>
                    </div>
                    <div v-if="multiasistencia" class="btn-group open" style="width: 50px; margin: 0;">
                        <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false" aria-controls="dropdownMenu2">
                            <i class="far fa-file"></i>
                        </button>
                        <ul id="dropdownMenu2" class="dropdown-menu" aria-labelledby="dropdownMenu2">
                            <li class="dropdown-item"><a href="#" @click="abrirventana()">Parte Genérico</a></li>
                            <li class="dropdown-item"><a href="#" @click="multi1()">{{ $t('Multiasesistencia 1') }}</a>
                            </li>
                            <li class="dropdown-item"><a href="#" @click="multi2()">{{ $t('Multiasesistencia 2') }}</a>
                            </li>
                            <li class="dropdown-item"><a href="#" @click="multi3()">{{ $t('Multiasesistencia 3') }}</a>
                            </li>
                        </ul>
                    </div>
                    <div v-else-if="mapfre" class="btn-group open" style="width: 50px; margin: 0;">
                        <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false" aria-controls="dropdownMenu2">
                            <i class="far fa-file"></i>
                        </button>
                        <ul id="dropdownMenu2" class="dropdown-menu" aria-labelledby="dropdownMenu2">
                            <li class="dropdown-item"><a href="#" @click="abrirventana()">Parte Genérico</a></li>
                            <li class="dropdown-item"><a href="#" @click="mapf()">Mapfre</a></li>
                        </ul>
                    </div>
                    <button v-else type="button" class="btn btn-default " v-on:click='abrirventana'
                        title="Parte Genérico">
                        <i v-if="visita.tiene_firma" class="fas fa-file-signature"></i>
                        <i v-else class="far fa-file"></i>
                    </button>
                </div>
                <div v-show="mostrarboton !=false && propsplanning != false" style="float:right;margin-top:5px;">
                    <span v-if="visita.visita.confirmar=='1'" class="badge bg-danger">Por confirmar</span>
                    <span v-else-if="visita.visita.cita_temporal > 0" class="badge bg-orange">Reserva</span>
                    <span v-else-if="visita.visita.realizado_operario == ''" class="badge bg-warning">Activa</span>
                    <span v-else class="badge bg-secondary">Finalizada</span>&nbsp;
                    <span v-if="visita.tiene_firma" class="badge bg-teal">Firmada</span>
                </div>
            </div>
            <servicio-datos-visitas-visita-archivos v-if="propsplanning != false" :servicio="servicio"
                :id="visita.visita.servicios_idservicios" :visita="visita" />
            <Dialog :blockScroll="false" :style="{ width: '50rem' }" header="Finalizar visita" v-model:visible="mostrarFinalizar"
                @update:visible="mostrarFinalizar = false">
                <div style="display: flex; flex-direction: column; align-items: center; ">
                    <h5>Trabajos realizados</h5>
                    <textarea v-model="trabajosRealizados" class="form-control" id="realizados" rows="4"
                        style="width: 70%;"></textarea>
                    <h5 style="margin-top: 10px;">Trabajos pendientes</h5>
                    <textarea v-model="trabajosPendientes" class="form-control" id="pendientes" rows="4"
                        style="width: 70%;"></textarea>
                    <button class="btn btn-sm btn-light" style="border: 1px solid grey;margin-top: 20px"
                        @click="finalizarvisita()">Finalizar</button>
                </div>
            </Dialog>
            <Dialog :style="{ width: '35rem' }" header="Eliminar cita" v-model:visible="mostrarMotivoEliminar"
                @update:visible="mostrarMotivoEliminar = false">
                <div style="display: flex; flex-direction: column;">
                    <p style="margin-bottom: 5px;">¿Desea eliminar esta cita?</p>
                    <p><b>{{ textoVisitaEliminar }}</b></p>
                    <h5 style="margin-top: 10px;">Motivo</h5>
                    <textarea v-model="motivoEliminar" class="form-control" rows="3"></textarea>
                    <small v-if="errorMotivoEliminar" style="color:red">El motivo es obligatorio</small>
                    <button class="btn btn-sm btn-light" style="border: 1px solid grey;margin-top: 20px"
                        @click="eliminarVisitaMotivo()">Eliminar</button>
                </div>
            </Dialog>
        </div>
        <div class="col-lg-12" v-show="propsplanning != false">
            <servicio-datos-visitas-visita-gestor v-show="propsplanning != false" :servicio="servicio"
                :id="visita.visita.servicios_idservicios" :visita="visita" />
        </div>
    </div>
    <visita-editar @actualizar="actualizar" :idservicio="visita.visita.servicios_idservicios"
        :idvisita="visita.visita.idvisitador" :visita="visita" :servicio="servicio" />
    <visita-confirmar @actualizar="actualizar" :idservicio="visita.visita.servicios_idservicios"
        :idvisita="visita.visita.idvisitador" :visita="visita" :finalizada="finalizada" />
    <form id="formcorreos" method="post" :action="'https://' + direccionglobal" target="ifrm1">
        <iframe id="ifrm1" name="ifrm1" style="display:none"></iframe>
    </form>
</template>
<script>
import Dialog from 'primevue/dialog';
import serviciosdatosvisitasvisitaoperario from './visita_operario.vue'
import serviciosdatosvisitasvisitacliente from './visita_cliente.vue'
import serviciosdatosvisitasvisitaarchivos from './visita_archivos.vue'
import serviciosdatosvisitasvisitagestor from './visita_gestor.vue'
import visitaeditar from './visita_editar.vue'
import visitaconfirmar from './visita_confirmar.vue'
import { PwgsApi } from '../../../../../services/PwgsApi';
export default ({
    props: ['id', 'servicio','visita','planning','colorboton','colorbotondos','colorbotontres','colorbotoncuatro','propsplanning','chatsvisita'],
    setup() {
        return;
    },
    components: {
        'visita-confirmar': visitaconfirmar,
        'visita-editar': visitaeditar,
        'servicio-datos-visitas-visita-gestor': serviciosdatosvisitasvisitagestor,
        'servicio-datos-visitas-visita-operario': serviciosdatosvisitasvisitaoperario,
        'servicio-datos-visitas-visita-cliente': serviciosdatosvisitasvisitacliente,
        'servicio-datos-visitas-visita-archivos': serviciosdatosvisitasvisitaarchivos,
        Dialog,
    },
    data() {
        return {
            mostrarplanning:true,
            confirmar:false,
            mostrarPresupuesto: false,
            url: "",
            mostrarboton: false,
            mostrarbotondos: false,
            mostrarbotontres: false,
            colorbotonpresup:'',
            multiasistencia: false,
            ms:[],
            mapfre: false,
            mapfreUrl:'',
            finalizada: false,
            visible:false,
            visibleConfirmar: false,
            ste:false,
            visitaAMostrar:this.$props.visita,
            trabajosRealizados:'',
            trabajosPendientes:'',
            mostrarFinalizar: false,
            direccionglobal: '',
            mostrarFechaEnDomicilio: false,
            mostrarFechaFin: false,
            mostrarMotivoEliminar: false,
            motivoEliminar: '',
            errorMotivoEliminar: false,
            textoVisitaEliminar: '',
        }
    },
    emits: ['cerrar','actualizar', 'recargar'],
    methods: {
        actualizar(){
            this.$emit('actualizar');
        },
        
        mostrarFinalizarBtn(){            
            this.trabajosRealizados = '';
            this.trabajosPendientes = '';
            this.mostrarFinalizar = true;
        },
        mapf(){
            //let urlglobal = localStorage.getItem('direccion');
            window.open(this.mapfreUrl, "Mapfre", "width=800, height=600");
                this.$emit('cerrar'); 
            
        },
        multi1(){
            //let urlglobal = localStorage.getItem('direccion');
            window.open(this.ms[0], "Multiasistencia", "width=800, height=600");
                            this.$emit('cerrar'); 

        },
        multi2(){
            //let urlglobal = localStorage.getItem('direccion');
            window.open(this.ms[1], "Multiasistencia", "width=800, height=600");
                            this.$emit('cerrar'); 

        },
        multi3(){
            //let urlglobal = localStorage.getItem('direccion');
            window.open(this.ms[2], "Multiasistencia", "width=800, height=600");
                            this.$emit('cerrar'); 

        },
        accederservicio() {
            
            localStorage.setItem('nombreservicio' + this.$props.visita.visita.servicios_idservicios, this.$props.visita.visita.codigo_servicio);

            this.$router.push('/servicios/' + this.$props.visita.visita.servicios_idservicios);
        },
        async eliminarvisita(){

            //Las citas enviadas por interpwgs necesitan motivo de anulacion
            if(this.visita.interpwgs == 1){
                const fecha = this.visita.visita.fecha.split('-');
                this.motivoEliminar = '';
                this.errorMotivoEliminar = false;
                this.textoVisitaEliminar = fecha[2] + '/' + fecha[1] + '/' + fecha[0] + ' ' + this.visita.visita.hora.substring(0,5) + ' - ' + this.visita.visita.nombre_operario;
                this.mostrarMotivoEliminar = true;
                return;
            }
            
            this.$confirm.require({
                message: '¿Seguro que quieres eliminar la visita?',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Aceptar',
                accept: async() => {
                    const api = new PwgsApi();
                    try {
                        await api.delete('planning-pwgs/' + this.$props.id + '/eliminar-visita/' + this.visita.visita.idvisitador);
                        this.$toast.add({ severity: 'success', summary: 'Eliminada', detail: 'Cita eliminada correctamente', life: 2000 });

                        this.$emit('recargar', this.$props.id);
                        this.$emit('actualizar'); 
                        this.$emit('cerrar');

                        console.log("parent", this.$parent);
                    }
                    catch (error) {
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                    }
                   
                    
                },
                reject: () => {
                    return;
                }
            });
            
        },
        async eliminarVisitaMotivo(){
            if(!this.motivoEliminar.trim()){
                this.errorMotivoEliminar = true;
                return;
            }
            const api = new PwgsApi();
            try {
                await api.deletebody('planning-pwgs/' + this.$props.id + '/eliminar-visita/' + this.visita.visita.idvisitador, { motivo: this.motivoEliminar }, {});
                this.mostrarMotivoEliminar = false;
                this.$toast.add({ severity: 'success', summary: 'Eliminada', detail: 'Cita eliminada correctamente', life: 2000 });
                this.$emit('recargar', this.$props.id);
                this.$emit('actualizar');
                this.$emit('cerrar');
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async comprobarSe(){
            const api = new PwgsApi();            
            const se = await api.get('/servicios/'+this.id+'/comunicaciones-ste');
            if(se.comunicaciones==1){
                this.ste = true;
            }
        },
        cargardatos() {
            console.log('cargardatos', this.$props.visita);
            if(this.$props.visita.visita.confirmar==1){
                this.confirmar = true;
            }
            if (this.$props.planning > 0) {
                this.mostrarboton = true; 
                this.mostrarbotontres = true;
                this.mostrarPresupuesto = true;
            }
            if(this.$props.visita.visita.realizado_operario=='SI'){
                this.finalizada = true;
            }
            if(this.$props.visita.fichas_operario.completa_MULTIASISTENCIA_WS){
                this.multiasistencia = true;
                this.ms=[this.$props.visita.fichas_operario.completa_MULTIASISTENCIA_WS[0], this.$props.visita.fichas_operario.completa_MULTIASISTENCIA_WS[1], this.$props.visita.fichas_operario.completa_MULTIASISTENCIA_WS[2]];
            }
            if(this.$props.visita.fichas_operario.completa_MAPFRE){
                this.mapfre = true;
                this.mapfreUrl=[this.$props.visita.fichas_operario.completa_MAPFRE];
            }
            this.url = this.$props.visita.fichas_operario.completa_generico;
        },
        mostrarTrabajos() {
            localStorage.setItem("pestanyactivaservicio" + this.$props.visita.visita.servicios_idservicios,"trabajos");
            localStorage.setItem('nombreservicio' + this.$props.visita.visita.servicios_idservicios, this.$props.visita.visita.codigo_servicio);
            this.$router.push({ name: 'Servicio', params: { id: this.$props.visita.visita.servicios_idservicios } });

        },
        mostrarEditar() {
            this.visible = true;
        },
        mostrarConfirmar(){
            this.visibleConfirmar = true;
        },
        mostrarChat(planning) {
         if(planning != false){
            this.$parent.$parent.$parent.toggleComunicaciones();
         }
         else {
             document.getElementById('formcorreos').submit();
             var url = "https://" + this.direccionglobal + "/modulos/chat/panel.php?vista=vista_chats&destino_chat=" + this.visita.visita.operarios_idoperario + "&id_visita=" + this.visita.visita.idvisitador + "&id_servicio=" + this.$props.visita.visita.servicios_idservicios;
             window.open(url, "Chat", "width=800, height=600");            

         }
            },
        mostrarpresupuestos() {
        
                localStorage.setItem("pestanyactivaservicio" + this.$props.visita.visita.servicios_idservicios, "presupuestos");
                localStorage.setItem('nombreservicio' + this.$props.visita.visita.servicios_idservicios, this.$props.visita.visita.codigo_servicio);
                this.$router.push({ name: 'Servicio', params: { id: this.$props.visita.visita.servicios_idservicios } });
                
            
        },
        abrirventana() {
            //let urlglobal = localStorage.getItem('direccion');
            window.open(this.url, "Parte genérico", "width=800, height=600");
           
                this.$emit('cerrar'); 
            
        },
        async finalizarvisita() {
            const visita = this.visitaAMostrar;
            const api = new PwgsApi();
            if(this.trabajosRealizados == ''){
                alert("Debe rellenar los trabajos realizados");
                return;
            }
            const body = {'trabajos_realizados_cita': this.trabajosRealizados, 'trabajos_pendientes_cita': this.trabajosPendientes};            
            try{
                await api.put('planning-pwgs/'+this.$props.id+'/finalizar-visita/'+visita.visita.idvisitador, body);
                this.mostrarFinalizar = false;
                this.$parent.obtenerVisitas(this.$props.id, this.visita.visita.idvisitador); 
            }catch(e){
                alert(e);
                console.error('error',e);
            }
        },
        async smsoperario() {
            //PUT  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/enviar-sms-operario/:id_visita
            const api = new PwgsApi();
            try{
                await api.put("planning-pwgs/" + this.$props.id + "/enviar-sms-operario/" + this.$props.visita.visita.idvisitador);
                this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Sms enviado al operario correctamente', life: 2000 });

            }
             catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
            finally {
                this.$emit('cerrar'); 
            }
        },
        async smsasegurado() {
            //PUT  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/enviar-sms-asegurado/:id_visita
            const api = new PwgsApi();
            try {
                await api.put("planning-pwgs/" + this.$props.id + "/enviar-sms-asegurado/" + this.$props.visita.visita.idvisitador);
                this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Sms enviado al asegurado correctamente', life: 2000 });

            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
            finally {
                this.$emit('cerrar'); 
            }
        },
        async steasegurado() {
            //PUT  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/enviar-ste-firma/:id_visita
            const api = new PwgsApi();
            try{
                await api.put("planning-pwgs/" + this.$props.id + "/enviar-ste-firma/" + this.$props.visita.visita.idvisitador);
                this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Ste enviado correctamente', life: 2000 });

            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
            finally {
                this.$emit('cerrar'); 
            }
        },
        email(id){
            this.$emit('email', id);
        },
        async parteoperarioemail() {
            //PUT  modulos/pwgsapi/index.php/planning-pwgs/:id_servicio/enviar-ficha-operario/:id_visita
            const api = new PwgsApi();
            await api.put("planning-pwgs/" + this.visita.visita.servicios_idservicios + "/enviar-ficha-operario/" + this.visita.visita.idvisitador);
            this.$toast.add({ severity: 'success', summary: 'Enviado', detail: 'Enviada correctamente', life: 2000 });
            this.$emit('cerrar'); 
        },
        iraservicio() {
            localStorage.setItem('nombreservicio' + this.$props.visita.visita.servicios_idservicios, this.$props.visita.visita.codigo_servicio);
            this.$router.push({ name: 'Servicio', params: { id: this.$props.visita.visita.servicios_idservicios } });
            this.$emit("cerrar");
            this.$parent.$parent.close();
        },
        async obtenerParametro(nombreParam) {
            const api = new PwgsApi();
            const resp = await api.get(`parametros-pwgs/${nombreParam}`);
            return String(resp[nombreParam]) === '1';
        },
        async cargarParametrosFechaSeguimiento() {
            try {
                this.mostrarFechaEnDomicilio = await this.obtenerParametro('seguimiento_hora_en_dom');
            } catch (e) {
                this.mostrarFechaEnDomicilio = false;
            }

            try {
                this.mostrarFechaFin = await this.obtenerParametro('seguimiento_fecha_fin');
            } catch (e) {
                this.mostrarFechaFin = false;
            }
        },
        formatearFecha(fecha) {
            if(!fecha || fecha == '0') return '---';
            const fechaNueva = new Date(fecha * 1000);
            return fechaNueva.toLocaleDateString() + ' - ' + fechaNueva.toLocaleTimeString([], { timeZone: 'Europe/Madrid', hour: '2-digit', minute: '2-digit' });
        },  
    },
    mounted() {
        this.comprobarSe();
        this.cargardatos();
        this.cargarParametrosFechaSeguimiento();

        if (this.$props.propsplanning){
            this.mostrarplanning = this.$props.propsplanning;
        }
        this.direccionglobal = localStorage.getItem('direccion');

    },
    watch: {
        visita(newval){
            console.log("newval", newval);
        }
    },
    computed: {
        mostrarFechasVisita() {
            return this.mostrarFechaEnDomicilio || this.mostrarFechaFin;
        }
    }
})
</script>
<style>
.normal{
    background-color:green;
}
/* ConfirmDialog por encima de cualquier otro diálogo */
.p-confirm-dialog { z-index: 100010 !important; }
.p-dialog-mask:has(.p-confirm-dialog) { z-index: 100009 !important; }
</style>
